module.exports = __webpack_public_path__ + "img/product43_img03.69614f61.png";